import { MutableRefObject, useCallback } from "react";
import { AgGridReact } from "ag-grid-react";
import useUiuxStore from "src/store/useUiuxStore";
import { focusToCell } from "src/utils/grid/GridHandlerContent";
import { TQC1020_R01DetailDto } from "../Dto_TQC1020_R01";

interface UseTQC1020_R01ModalProps {
	detailGridRef: MutableRefObject<AgGridReact<TQC1020_R01DetailDto> | null>;
	updateTQC1020_R01ResultList: (valueIndex: number, data: TQC1020_R01DetailDto) => void;
	TQC1020_R01ResultList: TQC1020_R01DetailDto[];
	originalTQC1020_R01ResultList: TQC1020_R01DetailDto[];
}

export function useTQC1020_R01Modal({
	detailGridRef,
	updateTQC1020_R01ResultList,
	TQC1020_R01ResultList,
	originalTQC1020_R01ResultList,
}: UseTQC1020_R01ModalProps) {
	const { setCodeSearchModalProps } = useUiuxStore();

	const settingInspectorModalProps = useCallback(
		(search: string, originalData: TQC1020_R01DetailDto, valueIndex: number) => {
			setCodeSearchModalProps({
				category: "검사자",
				search,
				formName: "TQC1020_R01",
				isInfo: false,
				handleFoucsId: "inspectorEmp",
				onClear: () => {
					updateTQC1020_R01ResultList(valueIndex, {
						...originalData,
						inspectorEmp: "",
						inspectorEmpNm: "",
						isModified: !originalData.inserted,
					});
				},
				onConfirm: (data: any) => {
					const currentRow =
						TQC1020_R01ResultList.find((item) => item.valueIndex === valueIndex) ??
						originalTQC1020_R01ResultList.find((item) => item.valueIndex === valueIndex) ??
						originalData;

					updateTQC1020_R01ResultList(valueIndex, {
						...currentRow,
						inspectorEmp: data.empNo ?? "",
						inspectorEmpNm: data.empNm ?? "",
						isModified: !currentRow.inserted,
					});

					setTimeout(() => {
						focusToCell(detailGridRef, valueIndex, "inspectDt");
					}, 100);
				},
				wrapperOption: { size: "sm", width: 20, overlay: true },
			});
		},
		[
			setCodeSearchModalProps,
			updateTQC1020_R01ResultList,
			TQC1020_R01ResultList,
			originalTQC1020_R01ResultList,
			detailGridRef,
		],
	);

	return { settingInspectorModalProps };
}
